import { useTranslations } from "next-intl";
import type { ReactNode } from "react";

import { HeroCtaPanel, heroCtaEmphasis } from "./hero-cta-panel";

/** SECTION 5 — closing CTA panel (desktop). */
export function HeroCta(): ReactNode {
  const t = useTranslations("marketing.heroCta");
  return (
    <div style={{ maxWidth: 1240, margin: "48px auto 0", padding: "0 28px" }}>
      <HeroCtaPanel
        compact={false}
        headline={t.rich("siehWieVielLeichter", { i: heroCtaEmphasis })}
        sub={null}
        buttonLabel={t("demoCallBuchen")}
      />
    </div>
  );
}
